export const TABLE_CONTROLLER_EVENTS = {
    /** 单元格/行列选中区域变化 */
    SELECTED_INFO_UPDATE: 'selected-info-update',
    /** 行列线是否正处于拖拽的状态变化 */
    LINE_IS_DRAGGING_STATE_UPDATE: 'drag-line-state-update',
    /** 表格编辑态变化 */
    TABLE_EDIT_STATE_CHANGE: 'table-edit-state-change',
    /** 开始鼠标滚轮设置行/列数量 */
    START_MOUSE_WHEEL_SET_ROW_OR_COL_COUNT: 'start-mouse-wheel-set-row-or-col-count',
    /** 结束鼠标滚轮设置行/列数量 */
    END_MOUSE_WHEEL_SET_ROW_OR_COL_COUNT: 'end-mouse-wheel-set-row-or-col-count',
};
